export default {
    10: 'Failed to send request',
    300: 'No more connections notification',

    31135: 'Notify Action Closed Notification',
    71031: 'Leader board change summary notification',

    71032: 'Leader board change details notification',
    34001: 'Relogin by server',
    33004: 'Logged out by server',
    32010: 'Notify Balance Change Notification',
    31021: 'Dynamic Balance Notification',
    31010: 'Terms and Conditions Notification',
    31012: 'Change Password Notification',
    33005: 'Bonus Message Accept Notification',
    31026: 'Show Message Notification',
    31133: 'Show Action Notification',
    31009: 'Wrong authentication token',
    31027: 'Login messages from IMS',
    31014: 'Logout'
};
